function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
});

var SvgLinkedin = function SvgLinkedin(props) {
  return React.createElement("svg", _extends({
    "aria-hidden": "true",
    "data-prefix": "fab",
    "data-icon": "linkedin-in",
    className: "linkedin_svg__svg-inline--fa linkedin_svg__fa-linkedin-in linkedin_svg__fa-w-14",
    viewBox: "0 0 448 512"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/linkedin.1e01f0c0.svg";
export { SvgLinkedin as ReactComponent };